import { render, staticRenderFns } from "./candidate-availability.vue?vue&type=template&id=00bec8dd&scoped=true&"
import script from "./candidate-availability.vue?vue&type=script&lang=js&"
export * from "./candidate-availability.vue?vue&type=script&lang=js&"
import style0 from "./candidate-availability.vue?vue&type=style&index=0&id=00bec8dd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00bec8dd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
